import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import FormControlContext from 'src/app/components/FormControl/FormControlContext';
import styles from 'src/app/components/FormControl/FormControl.scss';


class FormControl extends React.Component {
  componentDidMount() {
    const timeForComponentPaint = 500;
    setTimeout(() => this.chromeAutofillDetection(), timeForComponentPaint);
  }

  chromeAutofillDetection() {
    // try and catch is here to mute SyntaxError caused by 'input:-webkit-autofill' in every browser except Chrome.
      try {
        [
          this.ref.current
        ]
          .filter((formControl) => formControl.querySelector('input:-webkit-autofill'))
          .forEach((element) => element.classList.add(styles['form-control--filled']));
      } catch (error) {} // eslint-disable-line no-empty
  }

  ref = React.createRef();

  render() {
    const {
      hint,
      focus,
      value,
      disabled,
      markedAsWrong,
      validationMessage,
      apiError,
      children,
      label,
      fixed
    } = this.props;
    const invalid = (markedAsWrong && validationMessage) || apiError;
    const classList = classNames({
      'styles.form-control': true,
      'styles.form-control--active': focus,
      'styles.form-control--filled': !!value,
      'styles.form-control--invalid': invalid,
      'styles.form-control--disabled': disabled,
      'styles.form-control--fixed': fixed
    });

    return (
      <FormControlContext.Provider value={ { ...this.props } }>
        <div ref={ this.ref } styleName={ classList }>
          { children }
          <label styleName="form-control__label">
            {label}
          </label>

          <div styleName="form-control__error"
               aria-live="polite"
               data-test="validation-summary-errors"
          >
            {validationMessage}
          </div>

          {!validationMessage && <div styleName="form-control__hint">{hint}</div>}
        </div>
      </FormControlContext.Provider>
    );
  }
}


FormControl.propTypes = {
  value: PropTypes.string.isRequired,
  validationMessage: PropTypes.string.isRequired,
  markedAsWrong: PropTypes.bool.isRequired,
  focus: PropTypes.bool.isRequired,
  apiError: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  fixed: PropTypes.bool,
  hint: PropTypes.string
};

FormControl.defaultProps = {
  disabled: false,
  fixed: false,
  hint: ''
};

export default FormControl;
